import { render, staticRenderFns } from "./showProperties.vue?vue&type=template&id=756ce745&scoped=true"
import script from "./showProperties.vue?vue&type=script&lang=js"
export * from "./showProperties.vue?vue&type=script&lang=js"
import style0 from "./showProperties.vue?vue&type=style&index=0&id=756ce745&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756ce745",
  null
  
)

export default component.exports